import { useState } from "react";
import { Link } from "react-router-dom";

const SUBMIT_ADDR = "https://readdy.ai/api/form/da261rrk8r5te5mqsi0g";

const footNav = [
  {
    title: "浏览内容",
    links: [
      { label: "首页", to: "/" },
      { label: "漫画库", to: "/manga" },
      { label: "最新资讯", to: "/news" },
      { label: "热门排行", to: "/#rank" },
    ],
  },
  {
    title: "关于樱花",
    links: [
      { label: "关于我们", to: "/about" },
      { label: "常见问题", to: "/faq" },
      { label: "联系我们", to: "/contact" },
      { label: "投稿指南", to: "/contact" },
    ],
  },
];

export default function Footer() {
  const [status, setStatus] = useState<"idle" | "success" | "error">("idle");
  const [message, setMessage] = useState("");
  const [email, setEmail] = useState("");

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const form = e.currentTarget;
    const fd = new FormData(form);

    const honeypot = fd.get("phone_alt") as string;
    if (honeypot && honeypot.trim().length > 0) {
      setStatus("success");
      setMessage("订阅成功，感谢你的关注！");
      form.reset();
      setEmail("");
      return;
    }

    const payload = new URLSearchParams();
    fd.forEach((value, key) => {
      if (key !== "phone_alt" && String(value).trim() !== "") {
        payload.append(key, String(value));
      }
    });

    try {
      const res = await fetch(SUBMIT_ADDR, {
        method: "POST",
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
        body: payload.toString(),
      });
      const responseText = await res.text();
      let parsed: { code?: string; message?: string; meta?: { message?: string; detail?: string } } | null =
        null;
      try {
        parsed = JSON.parse(responseText);
      } catch {
        parsed = null;
      }
      const serverMsg =
        parsed?.meta?.message ||
        parsed?.meta?.detail ||
        parsed?.message ||
        responseText;
      const isSpam = /spam/i.test(responseText);
      const ok =
        res.ok &&
        !isSpam &&
        (parsed?.code === "OK" || (parsed && parsed.code === undefined && res.ok));

      if (ok) {
        setStatus("success");
        setMessage("订阅成功，每周漫讯将准时送到你的邮箱。");
        form.reset();
        setEmail("");
      } else {
        setStatus("error");
        setMessage(serverMsg || "订阅失败，请稍后再试。");
      }
    } catch {
      setStatus("error");
      setMessage("网络异常，订阅失败，请稍后再试。");
    }
  };

  return (
    <footer className="mt-auto bg-background-200">
      <div className="mx-auto max-w-7xl px-4 md:px-6 py-12 md:py-16">
        <div className="grid grid-cols-1 gap-10 md:grid-cols-2 lg:grid-cols-4">
          <div className="lg:col-span-1">
            <Link to="/" className="flex items-center gap-2" aria-label="樱花漫画首页">
              <span className="flex h-9 w-9 items-center justify-center rounded-full bg-primary-500 text-background-50">
                <i className="ri-flower-fill text-lg" aria-hidden="true"></i>
              </span>
              <span className="font-heading text-xl font-bold text-foreground-950">
                樱花<span className="text-primary-600">漫画</span>
              </span>
            </Link>
            <p className="mt-4 text-sm leading-relaxed text-foreground-600">
              专注国产漫画的推荐与资讯平台，聚合热门排行、作品分类与深度专题，帮你发现每一部值得追的漫画。
            </p>
            <div className="mt-5 flex items-center gap-3">
              <a
                href="#"
                aria-label="微博"
                className="flex h-9 w-9 items-center justify-center rounded-full bg-background-50 text-foreground-700 transition-colors hover:bg-primary-500 hover:text-background-50"
              >
                <i className="ri-weibo-line" aria-hidden="true"></i>
              </a>
              <a
                href="#"
                aria-label="哔哩哔哩"
                className="flex h-9 w-9 items-center justify-center rounded-full bg-background-50 text-foreground-700 transition-colors hover:bg-accent-500 hover:text-background-50"
              >
                <i className="ri-bilibili-fill" aria-hidden="true"></i>
              </a>
              <a
                href="#"
                aria-label="公众号"
                className="flex h-9 w-9 items-center justify-center rounded-full bg-background-50 text-foreground-700 transition-colors hover:bg-secondary-500 hover:text-background-50"
              >
                <i className="ri-chat-3-line" aria-hidden="true"></i>
              </a>
            </div>
          </div>

          {footNav.map((col) => (
            <div key={col.title}>
              <h3 className="font-heading text-base font-bold text-foreground-950">
                {col.title}
              </h3>
              <ul className="mt-4 space-y-3">
                {col.links.map((link) => (
                  <li key={link.label}>
                    <Link
                      to={link.to}
                      className="text-sm text-foreground-600 transition-colors hover:text-primary-700"
                    >
                      {link.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}

          <div>
            <h3 className="font-heading text-base font-bold text-foreground-950">
              订阅每周漫讯
            </h3>
            <p className="mt-4 text-sm text-foreground-600">
              每周精选新作、专题与行业动态，免费订阅，随时退订。
            </p>
            <form
              data-readdy-form="newsletter"
              className="mt-4 flex flex-col gap-3"
              onSubmit={handleSubmit}
            >
              <label htmlFor="newsletter-email" className="sr-only">
                电子邮箱
              </label>
              <input
                id="newsletter-email"
                type="email"
                name="email"
                required
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="输入你的邮箱"
                autoComplete="email"
                className="w-full rounded-md border border-background-300 bg-background-50 px-4 py-2.5 text-sm text-foreground-900 placeholder:text-foreground-400 focus:border-primary-400 focus:outline-none focus:ring-2 focus:ring-primary-200"
              />
              <input
                type="text"
                name="phone_alt"
                tabIndex={-1}
                autoComplete="off"
                aria-hidden="true"
                readOnly
                className="hp-field"
              />
              <button
                type="submit"
                className="inline-flex w-full items-center justify-center whitespace-nowrap rounded-md bg-primary-500 px-5 py-2.5 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600"
              >
                立即订阅
                <i className="ri-send-plane-fill ml-2 text-sm" aria-hidden="true"></i>
              </button>
              {status !== "idle" && (
                <p
                  className={`text-xs ${
                    status === "success" ? "text-secondary-700" : "text-primary-700"
                  }`}
                  role="status"
                >
                  {message}
                </p>
              )}
            </form>
          </div>
        </div>

        <div className="mt-10 flex flex-col items-center justify-between gap-3 border-t border-background-300/70 pt-6 sm:flex-row">
          <p className="text-xs text-foreground-600">
            © 2026 樱花漫画 SakuraManga. 本站为漫画推荐与资讯平台。
          </p>
          <div className="flex flex-wrap items-center gap-5">
            <Link to="/about" className="text-xs text-foreground-600 hover:text-primary-700">
              内容原则
            </Link>
            <Link to="/faq" className="text-xs text-foreground-600 hover:text-primary-700">
              免责声明
            </Link>
            <Link to="/contact" className="text-xs text-foreground-600 hover:text-primary-700">
              商务合作
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
}